import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose Us</span> As Your Trusted Web3 Development
              Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              As a reputable Web3 app development company, we have a deep
              understanding and knowledge of the latest trends in
              decentralization that redefine the digital industry.
            </p>
            <p>
              Here's why you should choose us as your reliable web 3.0
              development company:
            </p>
            <p>
              <strong>Expertise & Experience:</strong> We have a proven track
              record in Web3 development and can confidently handle any
              challenges with blockchain technology.
            </p>
            <p>
              <strong>Communication:</strong> We adopt agile methods and
              practice transparent communications for instant insights, thus
              fostering collaborative development innovations.
            </p>
            <p>
              <strong>Scalability:</strong> We ensure smooth app growth using
              scalable architectures, the latest technology, and optimal
              performance.
            </p>
            <p>
              <strong>Technical Proficiency:</strong> Our developers excel in
              modern frameworks, showcasing technical mastery for complex Web3
              app projects.
            </p>
            <p>
              <strong>Cost-Effectiveness:</strong> We maximize efficiency
              through coding and agile workflows, ensuring cost-effectiveness
              without compromising app quality.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/web3/why_choose.webp"
              alt="tekrevol Web3 Development"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={910}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
